import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

export const CheckCircleIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.00065 0.333252C3.32732 0.333252 0.333984 3.32659 0.333984 6.99992C0.333984 10.6733 3.32732 13.6666 7.00065 13.6666C10.674 13.6666 13.6673 10.6733 13.6673 6.99992C13.6673 3.32659 10.674 0.333252 7.00065 0.333252ZM10.1873 5.46659L6.40732 9.24659C6.31398 9.33992 6.18732 9.39325 6.05398 9.39325C5.92065 9.39325 5.79398 9.33992 5.70065 9.24659L3.81398 7.35992C3.62065 7.16659 3.62065 6.84659 3.81398 6.65325C4.00732 6.45992 4.32732 6.45992 4.52065 6.65325L6.05398 8.18659L9.48065 4.75992C9.67398 4.56659 9.99399 4.56659 10.1873 4.75992C10.3807 4.95325 10.3807 5.26659 10.1873 5.46659Z"
        fill="#028B3D"
      />
    </SvgIcon>
  )
}
